import { NgModule } from '@angular/core';
import {RemoveAfterDirective} from "./remove-after.directive";

@NgModule({
  imports: [],
  declarations: [
    RemoveAfterDirective,
  ],
  exports: [
    RemoveAfterDirective,
  ]
})
export class SharedDirectivesModule {}
